// import React from 'react';
// import './LoadingSpinner.css'

// const LoadingSpinner: React.FC = () => {
//   return (
//     <div className="loading-spinner-overlay">
//       <div className="loading-spinner-container">
//         <div className="loading-spinner"></div>
//       </div>
//     </div>
//   );
// };

// export default LoadingSpinner;

import React, { FC } from 'react';
import styled, { keyframes } from 'styled-components';
import animationData from '../../Loader.json'
import './LoadingSpinner.css'
import Lottie from 'lottie-react';


// Keyframe animation for spinning
const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Styled components for the spinner
const SpinnerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const SpinnerContainer = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #0AFC7F; /* Green background */
  animation: ${spinAnimation} 1s linear infinite;
  position: relative;
`;

const LoadingSpin = styled.div`
position: absolute;
  top: 50%;
  left: 50%;
  background: transparent;
  transform: translate(-50%, -50%);
  border-right: 4px solid #000;
  border-radius: 50%;
  border-top: 4px solid #000;
  border-bottom: 4px solid #0AFC7F;
  border-left: 4px solid #0AFC7F;
  width: 80px;
  height: 80px;
`;

const LoadingSpinner: FC = () => {

  return (
    <SpinnerOverlay>
      <Lottie animationData={animationData} loop={true} style={{ width: 180, height: 180 }}/>
    </SpinnerOverlay>
    // <SpinnerOverlay>
    //     <SpinnerContainer>
    //         <LoadingSpin></LoadingSpin>
    //     </SpinnerContainer>
    // </SpinnerOverlay>
  );
};

export default LoadingSpinner;
